<template>
  <div>
    <memlist-modal size="xl" ref="modal">

      <m-row>
        <m-col lg="12">
          <h3 class="text-center">Bekräfta utskick</h3>
          <hr/>
          <p class="text-center">Bekräfta att all information är korrekt innan ni startar utskicket.</p>
        </m-col>
      </m-row>

      <m-row class="mt-8">
        <m-col lg="6">
          <span style="font-weight: 500;">Mottagare</span>
          <hr/>

          <m-row>
            <m-col cols="6" >
              <div class="bottom-alignment">
                <strong>{{ $t('MEMBER.NUM_ROWS') }}:</strong> {{ total_rows }}
              </div>

            </m-col>
            <m-col cols="6">
              <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

                <memlist-pagination 
                  :per_page="per_page" 
                  :total_rows="total_rows" 
                  @page-changed="current_page = $event"
                  @per-page-changed="per_page = $event"
                />

              </div>
            </m-col>
          </m-row>

          <m-row>
            <m-col lg="12">

              <memlist-ajax-table
                id="recipent-table"
                :fields="recipient_fields"
                :items="ajax_pagination"
                :per_page="per_page"
                :current_page="current_page"
                ref="recipent-table"
              >
              <template #cell(status)="row">

                <memlist-badge status="success" v-if="row.item.clicked_at">{{ $t('EMAIL_QUEUE.CLICKED') }}</memlist-badge>
                <memlist-badge status="success" v-else-if="row.item.opened_at">{{ $t('EMAIL_QUEUE.OPENED') }}</memlist-badge>
                <memlist-badge status="primary" v-else-if="row.item.delivered_at">{{ $t('EMAIL_QUEUE.DELIVERED') }}</memlist-badge>
                <memlist-badge status="primary" v-else-if="row.item.status === 'sent'">{{ $t('EMAIL_QUEUE.SENT') }}</memlist-badge>
                <memlist-badge status="warning" v-else>{{ $t('EMAIL_QUEUE.PENDING') }}</memlist-badge>
                
              </template>
              </memlist-ajax-table>
            </m-col>
          </m-row>

        </m-col>
        <m-col lg="6">
          <span style="font-weight: 500;">{{ $t('SENDOUT.SUMMARY') }}</span>
          <hr/>


          <m-row>
            <m-col lg="6">
              <div class="text-preview">{{ local_sendout.template.text }}</div>
            </m-col>
            <m-col lg="6">

              <p><b>{{ $t('SENDOUT.TYPE') }}: </b> {{ type_text }}</p>
              <p><b>{{ $t('SENDOUT.ID') }}: </b> {{ local_sendout.sendout_id }}</p>
              <p><b>{{ $t('SENDOUT.START_AT') }}: </b> {{ sendout_at }}</p>
              
              <p><b>{{ $t('SENDOUT.NAME') }}: </b> {{ local_sendout.name }}</p>
              <p><b>{{ $t('SENDOUT.TEMPLATE_NAME') }}: </b> {{ local_sendout.template.name }}</p>
              <p><b>{{ $t('SENDOUT.PRIO') }}: </b> {{ prio_text }}</p>

              <p><b>{{ $t('SENDOUT.FROM_ID') }}: </b> {{ local_sendout.overrides.from_id }}</p>
              <p><b>{{ $t('SENDOUT.ESTIMATED_COST') }}: </b> {{ estimated_cost }}</p>
              
            </m-col>
          </m-row>

        </m-col>
      </m-row>

      <hr/>

      <m-row>
        <m-col lg="6">
          
        </m-col>
        <m-col lg="6">
          <memlist-button
            class="mt-4 mr-2"
            ref="cancel-sendout-button"
            variant="secondary"
            @click="cancel"

          >{{ $t('COMMON.CANCEL') }}</memlist-button>
          <memlist-spinner-icon-button
            class="mt-4"
            ref="start-sendout-button"
            variant="success"
            icon="fa fa-play"
            @click="start"
            :text="$t('SENDOUT.START')"

          >{{ $t('SENDOUT.START') }}</memlist-spinner-icon-button>
        </m-col>
      </m-row>

    </memlist-modal>
  </div>
  
</template>

<script>
import axios from 'axios';

export default {
  name: 'SendoutConfirmSMSModal',
  components: {

  },
  emits: ['confirmed'],
  watch: {
    sendout: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        if (this.sendout) {
          this.local_sendout = { ...this.sendout };

          if (!this.local_sendout.template) {
            this.local_sendout.template = {};
          }

          if (!this.local_sendout.overrides) {
            this.local_sendout.overrides = {};
          }
        }
        else {
          this.local_sendout = {
            overrides: {},
            template: {

            }
          };
        }

        if (this.$refs['start-sendout-button']) {
          this.$refs['start-sendout-button'].stop();
        }
        
      },
      immediate: true,
    },
    
  },

  props: {
    /**
     * Expected shape of `sendout`:
     * {
     *   name: String,
     *   startedAt: String | Number | Date,
     *   processed: Number,
     *   totalRecipients: Number,
     *   opensPerDay: [ { date: '2025‑07‑10', count: 123 }, … ],
     *   stats: {
     *     success: Number,
     *     softBounce: Number,
     *     hardBounce: Number,
     *     invalid: Number
     *   }
     * }
     */
    sendout: { type: Object, required: true }
  },
  computed: {

    estimated_cost() {
      return (this.total_rows || 0) * 0.95 * (this.local_sendout.template.num_sms || 1);
    },

    type_text() {
      return this.local_sendout.type === 'email' ? this.$t('SENDOUT.EMAIL') : this.$t('SENDOUT.SMS');
    },

    sendout_at() {
      if (this.local_sendout.scheduled_at) {
        return this.local_sendout.scheduled_at;
      }

      return this.$t('SENDOUT.DIRECT');
    },

    prio_text() {
      return this.$t('PAGES.SENDOUT.' + (this.local_sendout.prio || '').toUpperCase());
    },


    sendout_template_png () {

      // build the URL dynamically so it works in dev (localhost) and prod

      const { protocol, hostname } = window.location;

      // If you’re developing locally, always hit the API on port 3020.
      // Otherwise use the current host (no explicit port → 80 or 443).
      const base =
        hostname === 'localhost' || hostname === '127.0.0.1'
          ? `${protocol}//${hostname}:3020`
          : `${protocol}//${hostname}`;

      return `${base}/template-preview/${this.local_sendout.template_id}`;
    },

  },
  mounted() {
    
  },
  methods: {
    show() {
      this.$nextTick(()=>{
        this.$refs['modal'].show();
      });
    },
    hide() {
      this.$nextTick(()=>{
        this.$refs['modal'].hide();
      });
    },
    start() {
      this.$emit('confirmed');
    },
    cancel() {
      this.hide();
    },

    ajax_pagination: function(ctx, callback) {

      const vm = this;
      let params = {
        pageNo: ctx.current_page,
        pageSize: ctx.per_page,
        flag: 0,
        po: vm.searchOrderNumber,
        styNum: vm.searchStyleNumber
      };

      if (!this.local_sendout.sendout_id) {
        this.total_rows = 0;
        return;
      }

      axios
        .get(`/sendout/recipients/${this.local_sendout.sendout_id}`, {
          page: this.current_page,
          limit: this.per_page
        })
        .then(res => {
          this.total_rows = res.data.count;
          var arr = res.data.recipients;

          callback(arr || []);
        })
        .catch(err => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_GET_DATA'));
          console.error('pagination get error', err);
        });

      return null;
    },

  },
  data() {
    return {
      local_sendout: {
        overrides: {},
        template: {},
      },
      recipient_fields: [
        {
          visible: true,
          key: 'phone',
          label: this.$t('MEMBER.PHONE'),
          tdClass: 'td-overflow',
          thClass: 'td-overflow'
        },
        {
          visible: true,
          key: 'status',
          label: this.$t('EMAIL_QUEUE.STATUS'),
          tdClass: 'td-short3',
          thClass: 'td-short3',
        },
        
      ],
      per_page: 10,
      total_rows: 0,
      current_page: 0,
    }
  }
}
</script>

<style scoped>
.sendout-row canvas {
  /* Preserve small chart height without letting Chart.js stretch */
  max-height: 96px;
}
.text-preview {
  padding: 8px;
  border-radius: 12px;
  background-color: #218aff;
  color: #fdfdfd;
  font-weight: 500;
}
</style>
